var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cookie-law',{attrs:{"buttonText":_vm.$t('i_understand')}},[_c('div',{attrs:{"slot":"message"},slot:"message"},[_vm._v(" "+_vm._s(_vm.$t('cookie_message'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }